/**
 * PostHog WOM (Word of Mouth) event tracking for 18_march_energy
 * Tracks: wom_card (wom_product_card_clicked), non_wom_card (no_wom_product_card_clicked),
 * add_to_cart, buy_now, and all WOM-related events (filter, pagination, write review, etc.)
 * Uses capture-phase + composedPath() for Shadow DOM (WOM widgets).
 */
(function () {
  function capture(eventName, properties) {
    try {
      if (typeof window.posthog === 'undefined' || typeof window.posthog.capture !== 'function') return;
      window.posthog.capture(eventName, properties || {});
    } catch (e) {
      console.warn('[PostHog WOM]', e);
    }
  }

  function getText(el) {
    if (!el) return '';
    return (el.textContent || '').trim();
  }

  function getTextUp(el, maxDepth) {
    var depth = (maxDepth === undefined) ? 5 : maxDepth;
    var node = el;
    while (node && depth-- > 0) {
      var t = getText(node);
      if (t && t.length > 2) return t;
      node = node.parentElement || node.parentNode;
    }
    return getText(el);
  }

  function getPathText(path, maxLen) {
    var out = '';
    var len = (maxLen === undefined) ? 500 : maxLen;
    for (var i = 0; i < path.length && out.length < len; i++) {
      var node = path[i];
      if (node && node.nodeType === 1) {
        var t = getText(node);
        if (t && t.length < 200) out += ' ' + t;
      }
    }
    return out.trim();
  }

  function getWomWidgetFromPath(path) {
    if (!path || !path.length) return null;
    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (node && node.getAttribute) {
        var w = node.getAttribute('data-wom-widget');
        if (w === 'reviews' || w === 'social-proof') return w;
      }
    }
    return null;
  }

  function pathHasClass(path, classSubstr) {
    if (!path || !path.length) return false;
    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (!node || node.nodeType !== 1) continue;
      var cn = node.className;
      if (cn && typeof cn === 'string' && cn.indexOf(classSubstr) !== -1) return true;
    }
    return false;
  }

  function isInsideImageGallery(path) {
    return pathHas(path, 'data-wom-image-gallery') || pathHasClass(path, 'wom-image-gallery');
  }

  function pathHas(path, attr, value) {
    if (!path || !path.length) return false;
    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (!node || !node.getAttribute) continue;
      var v = node.getAttribute(attr);
      if (value === undefined || value === '') { if (v !== null && v !== undefined) return true; }
      else if (v === value) return true;
    }
    return false;
  }

  function isInsideReviewsWidget(path) {
    if (getWomWidgetFromPath(path) === 'reviews') return true;
    return pathHas(path, 'data-wom-rating-breakdown-container') ||
           pathHas(path, 'data-wom-reviews-list-container') ||
           pathHas(path, 'data-wom-reviews-layout') ||
           pathHas(path, 'data-wom-component', 'reviews') ||
           pathHas(path, 'data-wom-review-card') ||
           pathHas(path, 'id', 'reviews-pagination') ||
           pathHas(path, 'id', 'review-filters') ||
           pathHas(path, 'id', 'reviews-list');
  }

  function isWomFilterSelect(select) {
    if (!select || select.tagName !== 'SELECT') return false;
    if (select.className && typeof select.className === 'string') {
      if (select.className.indexOf('wom-filter-select') !== -1 || select.className.indexOf('filter-select') !== -1) return true;
    }
    if (select.id === 'review-filter-below-images' || select.id === 'main-filter') return true;
    if (!select.options || select.options.length < 2) return false;
    var hasAll = false, hasStar = false;
    for (var i = 0; i < select.options.length; i++) {
      var opt = select.options[i];
      var v = (opt.value || '').toLowerCase();
      var t = (opt.textContent || opt.text || '').toLowerCase();
      if (v === 'all' || t.indexOf('all review') !== -1) hasAll = true;
      if (v.indexOf('star') !== -1 || t.indexOf('star') !== -1 || v === 'highest' || v === 'lowest' || v === 'verified') hasStar = true;
    }
    return hasAll && hasStar;
  }

  function getProductContextFromForm(form) {
    var ctx = { productHandle: '', variantId: '' };
    if (!form) return ctx;
    var idInput = form.querySelector && form.querySelector('input[name="id"]');
    if (idInput && idInput.value) ctx.variantId = String(idInput.value);
    var picker = form.querySelector && form.querySelector('variant-picker[handle]');
    if (picker && picker.getAttribute('handle')) ctx.productHandle = picker.getAttribute('handle');
    if (!ctx.productHandle && window.location && window.location.pathname) {
      var m = window.location.pathname.match(/\/products\/([^\/\?]+)/);
      if (m) ctx.productHandle = m[1];
    }
    if (!ctx.productHandle && form.closest) {
      var card = form.closest('.product-card') || form.closest('product-card') || form.closest('.card-wrapper') || form.closest('.card');
      if (card && card.getAttribute && card.getAttribute('handle')) ctx.productHandle = card.getAttribute('handle');
    }
    return ctx;
  }

  // ---- Filter change ----
  document.addEventListener('change', function (e) {
    var target = e.target;
    if (!target || target.tagName !== 'SELECT') return;
    if (!isWomFilterSelect(target)) return;
    var val = target.value || 'all';
    capture('wom_filter_changed', { filterValue: val });
  }, true);

  // ---- Click tracking ----
  document.addEventListener('click', function (e) {
    var target = e.target;
    var path = (e.composedPath && e.composedPath()) || [];
    var widget = getWomWidgetFromPath(path);
    var pathText = getPathText(path);

    var clickEl = target && target.nodeType === 1 ? target : (target && (target.parentElement || target.parentNode));
    if (!clickEl || clickEl.nodeType !== 1) clickEl = target;
    var btn = clickEl.closest && (clickEl.closest('button') || clickEl.closest('a') || clickEl.closest('[role="button"]'));
    var label = (target.getAttribute && target.getAttribute('aria-label')) || '';
    if (btn) label = label || (btn.getAttribute && btn.getAttribute('aria-label')) || '';
    var text = getTextUp(btn || target);
    if (!text) text = getText(target);
    var combinedText = (text + ' ' + pathText).toLowerCase();

    // ---- Header login / account click ----
    var accountLink = clickEl && clickEl.closest && clickEl.closest('a');
    if (accountLink && accountLink.getAttribute('href') && (accountLink.getAttribute('href') || '').indexOf('/account') !== -1) {
      var inHeaderAccount = accountLink.closest && (accountLink.closest('.header__account-link') || accountLink.closest('header') || accountLink.closest('header-sidebar') || accountLink.closest('#sidebar-menu'));
      if (inHeaderAccount) {
        var isLogin = (accountLink.getAttribute('href') || '').indexOf('/account/login') !== -1;
        capture('login_clicked', { source: 'header', isLogin: isLogin });
        return;
      }
    }

    // ---- Cancel purchase: cart drawer close or continue shopping ----
    function pathContainsCartDrawer(pathArr) {
      if (!pathArr || !pathArr.length) return false;
      for (var i = 0; i < pathArr.length; i++) {
        var n = pathArr[i];
        if (!n) continue;
        if (n.id === 'cart-drawer') return true;
        if (n.tagName && n.tagName.toLowerCase() === 'cart-drawer') return true;
        if (n.className && typeof n.className === 'string' && n.className.indexOf('cart-drawer') !== -1) return true;
      }
      return false;
    }
    var inCartDrawer = pathContainsCartDrawer(path);
    if (inCartDrawer) {
      var isClose = label === 'Close' || (label && label.toLowerCase().indexOf('close') !== -1) ||
        (clickEl && clickEl.closest && clickEl.closest('dialog-close-button')) ||
        (target.closest && target.closest('dialog-close-button'));
      var isContinueShopping = /continue\s*shopping/i.test(text) || /continue\s*shopping/i.test(pathText);
      if (isClose || isContinueShopping) {
        capture('cancel_purchase_clicked', { source: isClose ? 'cart_drawer_close' : 'continue_shopping' });
        return;
      }
    }
    if (typeof window !== 'undefined' && window.location && (window.location.pathname === '/cart' || window.location.pathname.indexOf('/cart') !== -1)) {
      if (/continue\s*shopping/i.test(text) || /continue\s*shopping/i.test(pathText)) {
        capture('cancel_purchase_clicked', { source: 'cart_page_continue_shopping' });
        return;
      }
    }

    // ---- Prev/Next image in modal ----
    if (label === 'Previous image' || (btn && btn.getAttribute && btn.getAttribute('aria-label') === 'Previous image')) {
      capture('wom_review_image_prev_clicked', {});
      return;
    }
    if (label === 'Next image' || (btn && btn.getAttribute && btn.getAttribute('aria-label') === 'Next image')) {
      capture('wom_review_image_next_clicked', {});
      return;
    }

    // ---- Buy now / dynamic checkout ----
    var inPaymentButton = path.some(function (node) {
      return node && node.classList && node.classList.contains &&
        (node.classList.contains('shopify-payment-button') || node.classList.contains('shopify-payment-button__button'));
    });
    if (inPaymentButton) {
      var payForm = (target.closest && target.closest('form')) || (btn && btn.closest && btn.closest('form'));
      var payCtx = getProductContextFromForm(payForm);
      capture('buy_now_clicked', { productHandle: payCtx.productHandle, variantId: payCtx.variantId });
      return;
    }

    // ---- Add to cart (submit button, not inside payment button) ----
    var submitEl = clickEl && clickEl.closest && (clickEl.closest('button[type="submit"]') || clickEl.closest('input[type="submit"]'));
    if (submitEl && submitEl.form) {
      var form = submitEl.form;
      var action = (form.action || form.getAttribute('action') || '').toLowerCase();
      var isCartAdd = action.indexOf('cart/add') !== -1 || action.indexOf('/cart/add') !== -1;
      var formType = form.getAttribute && form.getAttribute('data-type');
      var isAddToCartForm = formType === 'add-to-cart-form';
      var insidePay = form.querySelector && form.querySelector('.shopify-payment-button') &&
        (form.querySelector('.shopify-payment-button').contains(target) || form.querySelector('.shopify-payment-button').contains(submitEl));
      if (!insidePay && (isCartAdd || isAddToCartForm)) {
        var atcCtx = getProductContextFromForm(form);
        capture('add_to_cart_clicked', { productHandle: atcCtx.productHandle, variantId: atcCtx.variantId });
        return;
      }
    }

    // ---- Product card: wom_card (WOM) vs non_wom_card (no WOM) ----
    var card = target.closest && (target.closest('.product-card') || target.closest('product-card') || target.closest('.t4s-col-item') || target.closest('.card-wrapper') || target.closest('.product-card-wrapper') || target.closest('.card') || target.closest('[data-product-handle]'));
    if (!card && target.closest) {
      var productLink = target.closest('a');
      if (productLink && productLink.getAttribute && (productLink.getAttribute('href') || '').indexOf('/products/') !== -1) card = productLink;
    }
    if (card) {
      var ratingEl = card.querySelector && card.querySelector('.wom-collection-rating');
      var hasWomInCard = ratingEl && (ratingEl.style.display === 'flex' || (window.getComputedStyle && window.getComputedStyle(ratingEl).display === 'flex'));
      if (hasWomInCard) {
        var handle = (ratingEl && ratingEl.getAttribute && ratingEl.getAttribute('data-product-handle')) ||
                    (card.getAttribute && card.getAttribute('handle')) || (card.getAttribute && card.getAttribute('data-product-handle')) || '';
        var title = (ratingEl && ratingEl.getAttribute && ratingEl.getAttribute('data-product-title')) ||
                    (card.querySelector && getText(card.querySelector('.product-title'))) || (card.querySelector && getText(card.querySelector('.card__heading'))) || '';
        if (!handle && card.getAttribute && card.getAttribute('href')) {
          var hm = (card.getAttribute('href') || '').match(/\/products\/([^\/\?]+)/);
          if (hm) handle = hm[1];
        }
        capture('wom_product_card_clicked', { productHandle: handle, productTitle: title });
        return;
      }
      var noWomHandle = (card.getAttribute && card.getAttribute('handle')) || (card.getAttribute && card.getAttribute('data-product-handle')) || '';
      var noWomTitle = (card.querySelector && getText(card.querySelector('.product-title'))) || (card.querySelector && getText(card.querySelector('.product-card__title'))) || (card.querySelector && getText(card.querySelector('.card__heading'))) || '';
      if (!noWomHandle && card.getAttribute && card.getAttribute('href')) {
        var nm = (card.getAttribute('href') || '').match(/\/products\/([^\/\?]+)/);
        if (nm) noWomHandle = nm[1];
      }
      capture('no_wom_product_card_clicked', { productHandle: noWomHandle, productTitle: noWomTitle });
      return;
    }

    // ---- WOM Social proof ----
    if (widget === 'social-proof' || pathHas(path, 'data-wom-component', 'social-proof')) {
      capture('wom_social_proof_clicked', {});
      capture('wom_view_all_reviews_clicked', { source: 'social_proof' });
      return;
    }

    // ---- From here: only consider clicks inside reviews widget ----
    if (!isInsideReviewsWidget(path)) return;

    // ---- Pagination: prev/next arrows and page numbers ----
    function pathHasSvgPathD(pathArr, leftRight) {
      for (var i = 0; i < pathArr.length; i++) {
        var n = pathArr[i];
        if (!n || n.nodeType !== 1) continue;
        if (n.tagName === 'path' && n.getAttribute) {
          var d = (n.getAttribute('d') || '').replace(/\s+/g, ' ');
          if (leftRight === 'prev' && (d.indexOf('M15 18') !== -1 || d.indexOf('15 18') !== -1)) return true;
          if (leftRight === 'next' && (d.indexOf('M9 18') !== -1 || d.indexOf('9 18') !== -1) && d.indexOf('15') === -1) return true;
        }
        var paths = n.querySelectorAll && n.querySelectorAll('path[d]');
        if (paths) for (var j = 0; j < paths.length; j++) {
          var pd = (paths[j].getAttribute('d') || '').replace(/\s+/g, ' ');
          if (leftRight === 'prev' && (pd.indexOf('M15 18') !== -1 || pd.indexOf('15 18') !== -1)) return true;
          if (leftRight === 'next' && pd.indexOf('M9 18') !== -1 && pd.indexOf('15') === -1) return true;
        }
      }
      return false;
    }
    var btnContent = btn ? (getText(btn) || (btn.innerHTML && btn.innerHTML.replace(/<[^>]+>/g, '').trim()) || '').trim() : '';
    var isPrevBtn = label === 'Previous page' || label === 'Previous Page' || btnContent === '\u2039' || btnContent === '\u00AB' || btnContent === '\u2190' || (btn && btn.innerHTML && btn.innerHTML.indexOf('\u2039') !== -1) || btnContent === '<' || pathHasSvgPathD(path, 'prev');
    var isNextBtn = label === 'Next page' || label === 'Next Page' || btnContent === '\u203A' || btnContent === '\u00BB' || btnContent === '\u2192' || (btn && btn.innerHTML && btn.innerHTML.indexOf('\u203A') !== -1) || btnContent === '>' || pathHasSvgPathD(path, 'next');
    if (btn && (isPrevBtn || isNextBtn) && !pathHas(path, 'data-wom-rating-breakdown-container')) {
      capture('wom_pagination_clicked', {
        type: 'arrow',
        direction: isPrevBtn ? 'prev' : 'next',
        linkText: label || (isPrevBtn ? 'Previous page' : 'Next page')
      });
      return;
    }

    var pageNum = btn ? getText(btn).trim() : (getText(target) || (clickEl && getText(clickEl)) || '').trim();
    if (btn && /^\d+$/.test(pageNum) && !pathHas(path, 'data-wom-rating-breakdown-container')) {
      capture('wom_pagination_clicked', { type: 'page', page: parseInt(pageNum, 10), linkText: pageNum });
      return;
    }
    var digitText = (clickEl && getText(clickEl)) || (target && getText(target)) || '';
    if (/^\d+$/.test(digitText.trim()) && !pathHas(path, 'data-wom-rating-breakdown-container')) {
      capture('wom_pagination_clicked', { type: 'page', page: parseInt(digitText.trim(), 10), linkText: digitText.trim() });
      return;
    }

    // ---- Write a review ----
    if (/write\s*(a\s*)?review/i.test(text) || /write\s*(a\s*)?review/i.test(pathText) || (combinedText.indexOf('write') !== -1 && combinedText.indexOf('review') !== -1)) {
      capture('wom_write_review_clicked', {});
      return;
    }

    // ---- Review image clicked ----
    if (pathHas(path, 'data-wom-review-card')) {
      if (target.tagName === 'IMG') {
        capture('wom_review_image_clicked', {});
        return;
      }
      for (var pi = 0; pi < path.length; pi++) {
        var n = path[pi];
        if (n && n.className && typeof n.className === 'string' && n.className.indexOf('wom-review-images-gallery') !== -1) {
          capture('wom_review_image_clicked', {});
          return;
        }
      }
    }

    // ---- View all images: only when click is inside customer photos gallery AND text is "view all images/photos" ----
    // The "View All" overlay only appears when there are more images than visible (e.g. > 7). No overlay = no click possible.
    var isInImageGallery = pathHas(path, 'data-wom-image-gallery') || pathHasClass(path, 'wom-image-gallery');
    var viewAllImagesText = /view\s*all\s*(images?|photos?)/i.test(text) || /view\s*all\s*(images?|photos?)/i.test(pathText);
    if (isInImageGallery && viewAllImagesText) {
      capture('wom_view_all_images_clicked', {});
      return;
    }

    // ---- View all reviews / Load more ----
    var viewAllReviewsMatch = /view\s*all\s*(reviews?)?|load\s*more\s*reviews?/i.test(text) || /view\s*all\s*(reviews?)?|load\s*more\s*reviews?/i.test(pathText) ||
        (combinedText.indexOf('load more') !== -1 && combinedText.indexOf('review') !== -1) ||
        (/view\s*all/i.test(combinedText) && isInsideReviewsWidget(path));
    if (viewAllReviewsMatch) {
      capture('wom_view_all_reviews_clicked', { source: 'button_or_link' });
      return;
    }

    // ---- Pagination: Load more link ----
    if (btn || (clickEl && clickEl.tagName === 'A')) {
      var href = (target.getAttribute && target.getAttribute('href')) || (btn && btn.getAttribute && btn.getAttribute('href'));
      var paginationText = getText(btn || clickEl || target);
      var paginationLower = paginationText.toLowerCase();
      if (/next|previous|prev/i.test(paginationText) || (href && /page=|\/page\//.test(href)) ||
          paginationLower.indexOf('load more') !== -1 || paginationLower === 'load more') {
        capture('wom_pagination_clicked', { type: 'link', linkText: paginationText, pageUrl: href || undefined });
        return;
      }
    }

    // ---- Star filters ----
    var filterValue = null;
    if (pathHas(path, 'data-wom-rating-breakdown-container') || pathHas(path, 'data-wom-reviews-list-container') || pathHas(path, 'data-wom-component', 'rating-breakdown')) {
      var filterText = text.replace(/\s+/g, ' ').trim();
      if (/^all\s*(reviews?)?$/i.test(filterText)) filterValue = 'all';
      else if (/^5\s*(\*|star)/i.test(filterText) || filterText === '5') filterValue = '5';
      else if (/^4\s*(\*|star)/i.test(filterText) || filterText === '4') filterValue = '4';
      else if (/^3\s*(\*|star)/i.test(filterText) || filterText === '3') filterValue = '3';
      else if (/^2\s*(\*|star)/i.test(filterText) || filterText === '2') filterValue = '2';
      else if (/^1\s*(\*|star)/i.test(filterText) || filterText === '1') filterValue = '1';
      if (!filterValue && /^\d$/.test(filterText)) filterValue = filterText;
      if (!filterValue && pathText.match(/\b(5|4|3|2|1)\s*star/i)) filterValue = pathText.match(/\b(5|4|3|2|1)\s*star/i)[1];
    }
    if (target.getAttribute && target.getAttribute('data-stars')) {
      filterValue = target.getAttribute('data-stars');
    }
    if (filterValue) {
      capture('wom_filter_changed', { filterValue: String(filterValue) });
    }
  }, true);
})();
